import { IAnswer, IQuestionSession } from '~/types/IQuestionSession';
import { siteAxios } from '.';

export const questionSession = {
  get: async (id: string) => {
    const { data } = await siteAxios.get<IQuestionSession>(
      `/api/v2/mw/question_sessions/${id}`
    );

    return data;
  },
  create: async () => {
    const { data } = await siteAxios.post<IQuestionSession>(
      '/api/v2/mw/question_sessions'
    );

    return data;
  },
  update: async (id: string, session: IQuestionSession) => {
    const { data } = await siteAxios.put<IQuestionSession>(
      `/api/v2/mw/question_sessions/${id}`,
      session
    );

    return data;
  },
  send: async (id?: string, email?: string) => {
    const { status } = await siteAxios.post(
      `/api/v2/mw/question_sessions/${id}/send`,
      { email },
      {
        validateStatus: () => true
      }
    );

    return status > 199 && status < 300;
  }
};

export const questionSessionAnswers = {
  getAll: async (sessionId: string) => {
    const { data } = await siteAxios.get<IAnswer[]>(
      `/api/v2/mw/question_sessions/${sessionId}/answers`
    );

    return data;
  },
  create: async (sessionId: string, answer: IAnswer) => {
    const { data } = await siteAxios.post<IAnswer>(
      `/api/v2/mw/question_sessions/${sessionId}/answers`,
      answer
    );

    return data;
  },
  update: async (id: string, sessionId: string, answer: IAnswer) => {
    const { data } = await siteAxios.put<IAnswer>(
      `/api/v2/mw/question_sessions/${sessionId}/answers/${id}`,
      answer
    );

    return data;
  }
};
